// extracted by mini-css-extract-plugin
module.exports =  {"fieldset":"iLfxu2NHN7ZbYX4SXYpS","label":"Qiz3xZLXMigvGeGr8Ljp"};